import cn from 'classnames';
import useProjectDetails from '../../useProjectDetails';
import ReceivedProjectRunBy from './components/ReceivedProjectRunBy/ReceivedProjectRunBy';
import OwnProjectRunBy from './components/OwnProjectRunBy/OwnProjectRunBy';
import styles from './ProjectRunBy.module.css';

type Props = {
    className?: string;
};

const ProjectRunBy = ({ className }: Props) => {
    const { project } = useProjectDetails();
    const isReceived = typeof project?.owned_by === 'number';

    return (
        <div className={cn(styles.container, className)}>
            <p className={styles.label}>Run by</p>
            {isReceived ? <ReceivedProjectRunBy /> : <OwnProjectRunBy />}
        </div>
    );
};

export default ProjectRunBy;
